<template>
    <div id="ContainerProvider">
        <div class="container-scroller">
            <div class="container-fluid page-body-wrapper full-page-wrapper">
                <div class="content-wrapper d-flex align-items-center auth px-0">
                    <div class="row w-100 mx-0">
                        <div class="col-lg-4 mx-auto">
                            <div class="auth-form-light text-left py-5 px-4 px-sm-5">
                                <div class="brand-logo">
                                    <img src="../../../assets/images/logo.svg" alt="logo" />
                                    <a
                                        v-on:click="logout"
                                        role="button"
                                        class="btn btn-light btn-sm float-right text-truncate mt-2"
                                        >{{ $t('AccountExpired.BtLogin') }}</a
                                    >
                                </div>

                                <div v-if="requiredBuilding">
                                    <b-row>
                                        <b-col>
                                            <h6 class="font-weight-bold">
                                                {{ $t('SelectUserRestriction.BuildingTitle') }}
                                            </h6>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <MdSelect
                                                v-bind:Options="buildingList"
                                                v-bind:Model="model.building"
                                                v-bind:FieldDescription="'description'"
                                                v-bind:FieldCode="'code'"
                                                v-bind:Multiple="false"
                                                v-bind:isRequired="true"
                                                v-bind:Placeholder="buildingPlaceholder"
                                                :Input="changeDropDownBuilding"
                                            />
                                        </b-col>
                                    </b-row>
                                </div>

                                <div v-if="requiredPharmacy" class="mt-3">
                                    <b-row>
                                        <b-col>
                                            <h6 class="font-weight-bold">
                                                {{ $t('SelectUserRestriction.PharmacyTitle') }}
                                            </h6>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <MdSelect
                                                v-bind:Options="pharmacyList"
                                                v-bind:Model="model.pharmacy"
                                                v-bind:FieldDescription="'description'"
                                                v-bind:FieldCode="'code'"
                                                v-bind:Multiple="false"
                                                v-bind:isRequired="true"
                                                v-bind:Placeholder="pharmacyPlaceholder"
                                                :Input="changeDropDownPharmacy"
                                            />
                                        </b-col>
                                    </b-row>
                                </div>

                                <div v-if="requiredProgram" class="mt-3">
                                    <b-row>
                                        <b-col>
                                            <h6 class="font-weight-bold">
                                                {{
                                                    $tc(
                                                        'SelectUserRestriction.ProgramTitle',
                                                        this.$store.state.allowMultiProgram ? 2 : 1
                                                    )
                                                }}
                                            </h6>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <MdSelect
                                                v-bind:Options="programList"
                                                v-bind:Model="model.programs"
                                                v-bind:FieldDescription="'description'"
                                                v-bind:FieldCode="'code'"
                                                v-bind:Multiple="
                                                    this.$store.state.allowMultiProgram
                                                "
                                                v-bind:isRequired="true"
                                                v-bind:Placeholder="programPlaceholder"
                                                :Input="changeDropDownPrograms"
                                            />
                                        </b-col>
                                    </b-row>
                                </div>

                                <div class="pt-3">
                                    <div class="mt-3">
                                        <MdButton
                                            v-bind:Label="$t('SelectProvider.ENTER')"
                                            v-bind:Name="'btnEnter'"
                                            v-bind:ClassProp="
                                                'btn btn-block btn-primary btn-login btn-lg font-weight-medium auth-form-btn text-truncate'
                                            "
                                            v-on:click="main"
                                            v-bind:isReadOnly="!saveButtonEnabled"
                                        >
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProviderService from '@/services/provider.service';
import UserService from '@/services/user.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import PermFunctions from '@/common/PermFunctions.js';
import DBFunctions from '@/common/DBFunctions.js';
import BuildingService from '@/services/building.service';
import ePharmacyItemsLocationService from '@/services/epharmacylocation.service';
import ProgramService from '@/services/programs.services';
import store from '@/globalvar.js';

export default {
    name: 'SelectUserRestrictions',
    mixins: [ShowMessage, PermFunctions, DBFunctions],
    data() {
        return {
            buildingPlaceholder: this.$t('SelectUserRestriction.BuildingPlaceholder'),
            pharmacyPlaceholder: this.$t('SelectUserRestriction.PharmacyPlaceholder'),
            programPlaceholder: this.$tc(
                'SelectUserRestriction.ProgramPlaceholder',
                this.$store.state.allowMultiProgram ? 2 : 1
            ),
            model: {
                building: [],
                pharmacy: [],
                programs: []
            },
            buildingList: [],
            pharmacyList: [],
            programList: []
        };
    },

    computed: {
        saveButtonEnabled() {
            let result = true;
            if (this.requiredBuilding) {
                result = result && this.model.building.length !== 0;
            }
            if (this.requiredPharmacy) {
                result =
                    result && (this.model.pharmacy.length !== 0 || this.pharmacyList.length === 0);
            }
            if (this.requiredProgram) {
                result = result && this.model.programs.length !== 0;
            }

            return result;
        },

        requiredBuilding() {
            return (
                this.$store.state.requiredBuildingLocation &&
                this.$store.state.requiredBuildingLocationList.length !== 1
            );
        },

        defaultBuilding() {
            if (
                this.$store.state.requiredBuildingLocation &&
                this.$store.state.requiredBuildingLocationList.length === 1
            ) {
                return this.$store.state.requiredBuildingLocationList[0];
            }

            return null;
        },

        requiredPharmacy() {
            return (
                this.$store.state.requiredPharmacy &&
                this.$store.state.requiredPharmacyList.length !== 1
            );
        },

        defaultPharmacy() {
            if (
                this.$store.state.requiredPharmacy &&
                this.$store.state.requiredPharmacyList.length === 1
            ) {
                return this.$store.state.requiredPharmacyList[0];
            }

            return null;
        },

        requiredProgram() {
            return (
                this.$store.state.requiredProgram &&
                this.$store.state.requiredProgramList.length !== 1
            );
        },

        defaultProgram() {
            if (
                this.$store.state.requiredProgram &&
                this.$store.state.requiredProgramList.length === 1
            ) {
                return [this.$store.state.requiredProgramList[0]];
            }

            return [];
        }
    },

    methods: {
        async changeDropDownBuilding(value) {
            this.model.building = value ? [value.code] : [];
            this.model.pharmacy = [];
            await this.getPharmacies(value ? value.code : null);
        },

        changeDropDownPharmacy(value) {
            this.model.pharmacy = value ? [value.code] : [];
        },

        changeDropDownPrograms(value) {
            this.model.programs = value
                ? Array.isArray(value)
                    ? value.map(x => x.code)
                    : [value.code]
                : [];
        },

        logout() {
            this.$bvModal
                .msgBoxConfirm(this.$t('SelectProvider.CloseSessionMsg'), {
                    title: this.$t('Shared.Logout'),
                    okTitle: this.$t('Shared.LogOut'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    this.IsOk = value;
                    if (this.IsOk) {
                        UserService.logout()
                            .then(response => {
                                if (response.status == '200') {
                                    this.$store.commit('setAccessToken', '');
                                    localStorage.removeItem('vuex');
                                    localStorage.removeItem('_secure__ls__metadata');
                                    this.$router.push('/login').catch(() => {});
                                }
                            })
                            .catch(error => {
                                if (!error.response) {
                                    this.showMessage(
                                        this.$tc('Msg.Error'),
                                        this.$t('SelectProvider.NoAbleToLogOutMsg'),
                                        'error'
                                    );
                                } else {
                                    this.showMessage(this.$tc('Msg.Error'), error, 'error');
                                }
                            });
                    }
                });
        },

        main() {
            /*this.$store.commit('setRestrictions', {
                buildingLocation: this.model.building,
                pharmacy: this.model.pharmacy,
                programs: this.model.programs
            });*/
            //this.$router.push('/app/main');
            ProviderService.SetUserRestrictions({
                    buildings: this.model.building,
                    pharmacies: this.model.pharmacy,
                    programs: this.model.programs
                })
                .then(response => {
                    if (response.status == '200') {
                        this.$store.commit('setRedirectToRestrictions', false);
                        store.commit('setAccessToken', JSON.stringify(response.data));
                        this.$router.push('/app/main');
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        async getBuildings() {
            if (this.requiredBuilding) {
                const requiredBuildingLocationList =
                    this.$store.state.requiredBuildingLocationList || [];
                const params = {
                    buildings: requiredBuildingLocationList.join(','),
                    active: true,
                    onlyCurrentEmployee: true
                };
                await BuildingService.getBuildingsLookup(params)
                    .then(response => {
                        if (response.status == '200') {
                            this.buildingList = response.data;
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, 'error');
                        }
                    });
            }
        },

        async getPharmacies(buildingCode) {
            if (this.requiredPharmacy) {
                const requiredPharmacyList = this.$store.state.requiredPharmacyList || [];
                const params = {
                    pharmacies: requiredPharmacyList.join(','),
                    Buildings: buildingCode,
                    onlyCurrentEmployee: true
                };
                await ePharmacyItemsLocationService
                    .getPharmaciesLookup(params)
                    .then(response => {
                        if (response.status == '200') {
                            this.pharmacyList = response.data;
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, 'error');
                        }
                    });
            }
        },

        async getPrograms() {
            if (this.requiredProgram) {
                const requiredProgramList = this.$store.state.requiredProgramList || [];
                const params = {
                    programs: requiredProgramList
                };
                await ProgramService.getProgramsLookup(params)
                    .then(response => {
                        if (response.status == '200') {
                            this.programList = response.data;
                        }
                    })
                    .catch(error => {
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'), error, 'error');
                        }
                    });
            }
        }
    },

    async mounted() {
        this.model = {
            building: this.defaultBuilding ? [this.defaultBuilding] : [],
            pharmacy: this.defaultPharmacy ? [this.defaultPharmacy] : [],
            programs: this.defaultProgram
        };

        await Promise.all([
            await this.getBuildings(),
            await this.getPharmacies(this.defaultBuilding),
            await this.getPrograms()
        ]);
    }
};
</script>
